import React from 'react';

import css from './Table.module.scss';

const Table = ({ heading, tableHeading, data }) => {
	return (
		<div className={css.table}>
			<h3>{heading}</h3>
			<div className={css.tableWrapper}>
				<table>
					<thead>
						<tr>
							{tableHeading.map((item, index) => (
								<th key={index}>{item}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{data.map(item => (
							<tr>
								{Object.keys(item).map((key, index) => {
									return key === 'id' ? null : (
										<td key={index + 100}>{item[key]}</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Table;
